import script from "./attendancePage.vue?vue&type=script&setup=true&lang=js"
export * from "./attendancePage.vue?vue&type=script&setup=true&lang=js"

import "./attendancePage.vue?vue&type=style&index=0&id=a78d495c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a78d495c"]])

export default __exports__